import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { useAppSelector } from '@redux/hooks';
import { useSetAtom } from 'jotai';
import { useReducerAtom } from 'jotai/utils';
import React, { type FC } from 'react';
import VendorAnalytics from '../../../../../decorators/vendorAnalytics';
import {
	currentStarRatingsAtom,
	fetchReviewsAtom,
	previousStarRatingsAtom,
	searchSortFilterAtom,
	searchSortFilterReducer,
} from '../atoms';
import { BaseAppliedPill } from './base-applied-pill';

export interface StarPillProps {
	text: string;
}

const StarPill: FC<StarPillProps> = (props) => {
	const { text } = props;
	const setCurrentStarRatings = useSetAtom(currentStarRatingsAtom);
	const setPreviousStarRatings = useSetAtom(previousStarRatingsAtom);
	const [, dispatch] = useReducerAtom(
		searchSortFilterAtom,
		searchSortFilterReducer,
	);
	const fetchReviews = useSetAtom(fetchReviewsAtom);
	const { track } = useAnalyticsContext();
	const vendor = useAppSelector((state) => state.vendor.vendor);

	const handleClose = () => {
		const vendorAnalytics = vendor
			? new VendorAnalytics(vendor).baseEventProps()
			: {};

		setCurrentStarRatings((prevState) => {
			const nextSet = prevState.slice();
			const result = nextSet.filter((t) => t !== text);
			const ratings = result.map((rating) =>
				Number.parseInt(rating.split(' ')[0], 10),
			);
			setPreviousStarRatings(result);
			dispatch({ type: 'remove-star-rating', payload: ratings });
			return result;
		});

		fetchReviews();

		track({
			event: 'Review Interaction',
			properties: {
				...vendorAnalytics,
				action: 'remove filter',
			},
		});
	};

	return <BaseAppliedPill label={text} onClose={handleClose} />;
};

export { StarPill };
